<template>
  <vue-good-table
    :columns="columns"
    :rows="tickets"
    :search-options="{
      enabled: true,
      trigger: 'enter',
    }"
    :pagination-options="{
      enabled: true,
      perPage: 20,
    }"
    styleClass="vgt-table condensed myGoodTable"
  >
    <template slot="table-row" slot-scope="props">
      <span v-if="props.column.field == 'ref'">
        <router-link :to="{ name: routeName, params: { ref: props.row.ref } }">
          <b>{{ props.row.ref }}</b>
        </router-link>
      </span>
      <span v-if="props.column.field == 'status'">
        <span v-if="props.row.status.slug == 'open'" class="badge badge-danger">{{ props.row.status.name }}</span>
        <span v-else-if="props.row.status.slug == 'closed'" class="badge badge-success">{{ props.row.status.name }}</span>
        <span v-else-if="props.row.status.slug == 'escalated'" class="badge badge-warning">{{ props.row.status.name }}</span>
      </span>
      <span v-if="props.column.field == 'categoryName'">{{ props.row.category.name }}</span>
      <span v-if="props.column.field == 'subcategoryName'">{{ props.row.subCategory.name }}</span>
      <span v-if="props.column.field == 'title'">{{ props.row.title }}</span>
      <span v-if="props.column.field == 'userName'">{{ props.row.user.name }} - {{ props.row.user.phone }}</span>
      <span v-if="props.column.field == 'agentName'">{{ props.row.agent.name }} - {{ props.row.agent.phone }}</span>
      <span v-if="props.column.field == 'createdAt'">{{ props.row.createdAt | formatDateTime }}</span>
    </template>
  </vue-good-table>
</template>

<script>
export default {
  props: {
    tickets: { type: Array },
    routeName: String,
  },
  computed: {
    columns() {
      let cols = [
        {
          label: "ReferenceID",
          field: "ref",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: this.client.topCategoryLabel,
          field: "categoryName",
        },
        {
          label: this.client.subCategoryLabel,
          field: "subcategoryName",
        },
        {
          label: "Subject",
          field: "title",
        },
        {
          label: "Created By",
          field: "userName",
        },
        {
          label: "Assigned To",
          field: "agentName",
        },
        {
          label: "Data/Time",
          field: "createdAt",
        },
      ];
      return cols;
    },

    client() {
      return this.$store.state.client;
    },
  },
};
</script>

<style>
.myGoodTable {
  font-size: 14px !important;
}
</style>